import React, { useMemo } from 'react';
import MarkdownIt from 'markdown-it';
import createDOMPurify from 'dompurify';

const { sanitize } = createDOMPurify(window);

let md;

export default function useMarkdown(message, Component) {
  if (!md) {
    md = new MarkdownIt();
  }

  return useMemo(() => {
    if (!message) {
      return;
    }

    const cleanedMessage = sanitize(md.render(message));

    return <Component dangerouslySetInnerHTML={{__html: cleanedMessage}} />;
  },
  [message]);
}
